import React from 'react'
import styled from 'styled-components'
import { BlockLink, Button, Flex, Text, Box } from 'pcln-design-system'
import { LogoPricelineVip } from '@pcln/vip'
import PricelineLogo from './PricelineLogo'
import { HotelListing } from './types'
import { trackCrossSellClicks } from './utils'
import {
  ProductImage,
  ProductFlexBorder,
  ProductTitle,
  SecondaryText,
  PrimaryText,
  ProductWrapper,
  StyledSup
} from './Common'

const HotelImage = styled(ProductImage)`
  height: 102px;
`

const FeatureBox = styled(Box)`
  border-radius: 2px;
`

const LocationText = styled(SecondaryText)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const StyledLogoPricelineVip = styled(LogoPricelineVip)`
  font-size: 24px;
  height: 24px;
  line-height: 1;
`

export default function HotelProduct({
  currencySymbol,
  currentPrice,
  guestRating,
  href,
  imageUrl,
  location,
  name,
  originalPrice,
  savingPercentage,
  starRating
}: HotelListing) {
  return (
    <ProductWrapper>
      <ProductFlexBorder>
        <HotelImage bgImage={imageUrl} />
        <Flex flexDirection="column" width="172px" px={3} py={2}>
          <ProductTitle mb="6px">{name}</ProductTitle>
          <LocationText fontWeight="bold" color="text.light" mb={2}>
            {location}
          </LocationText>
          <Flex alignItems="center">
            <FeatureBox mr={2} color="alert">
              <SecondaryText color="text.lightest" px="6px" fontWeight="bold">
                {guestRating}
              </SecondaryText>
            </FeatureBox>
            <SecondaryText fontWeight="bold">
              {starRating}-Star Hotel
            </SecondaryText>
          </Flex>
        </Flex>
      </ProductFlexBorder>
      <Flex py={2} flexDirection="column" mb={1}>
        <Flex alignItems="center" px={3}>
          <PricelineLogo />
          <StyledLogoPricelineVip px={2} variation="vip" />
          {savingPercentage && savingPercentage > 0 && (
            <PrimaryText color="primary.dark" px="6px" fontWeight="bold">
              {savingPercentage}% off
            </PrimaryText>
          )}
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex flexDirection="column" px={3}>
            {originalPrice > 0 && (
              <SecondaryText fontWeight="bold">
                was {currencySymbol}
                {originalPrice}
              </SecondaryText>
            )}
            <Flex alignItems="baseline">
              <Text fontSize={3} fontWeight="bold" mr={1} color="primary.dark">
                <StyledSup>{currencySymbol}</StyledSup>
                {currentPrice}
              </Text>
              <PrimaryText color="text.light" fontSize={0}>
                per night
              </PrimaryText>
            </Flex>
          </Flex>
          <BlockLink onClick={trackCrossSellClicks} href={href} target="_new">
            <Button color="secondary" mx={1}>
              Choose
            </Button>
          </BlockLink>
        </Flex>
      </Flex>
    </ProductWrapper>
  )
}
